import React, { useMemo, useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { MdOutlineCancel } from 'react-icons/md';
import { AiOutlinePlus } from 'react-icons/ai';
import css from './EditListingPhotosForm.module.css';
const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out',
};

const focusedStyle = {
  borderColor: '#2196f3',
};

const acceptStyle = {
  borderColor: '#00e676',
};

const rejectStyle = {
  borderColor: '#ff1744',
};

let currentId = 0;

function getNewId() {
  // we could use a fancier solution instead of a sequential ID :)
  return ++currentId;
}

function FileUploader(props) {
  const { onUpload, selectedFile, onFileRemove, fileFormatError } = props;

  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      onUpload(file);
    });
  }, []);

  const { getRootProps, getInputProps, isFocused, isDragAccept, isDragReject, acceptedFiles } =
    useDropzone({ onDrop });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isFocused, isDragAccept, isDragReject]
  );

  const files = selectedFile.map((file, idx) => (
    <React.Fragment key={`${file.path}${idx}`}>
      <li key={`${file.path}${idx}`}>
        <div className="licontent">
          <p>{file.path}</p>
          <div onClick={() => onFileRemove(file.path)}>
            <div className="rvbtnpdf">
              <svg
                width="10px"
                height="10px"
                viewBox="0 0 10 10"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g strokeWidth="1" fillRule="evenodd">
                  <g transform="translate(-821.000000, -311.000000)">
                    <g transform="translate(809.000000, 299.000000)">
                      <path
                        d="M21.5833333,16.5833333 L17.4166667,16.5833333 L17.4166667,12.4170833 C17.4166667,12.1866667 17.2391667,12 17.00875,12 C16.77875,12 16.5920833,12.18625 16.5920833,12.41625 L16.5883333,16.5833333 L12.4166667,16.5833333 C12.18625,16.5833333 12,16.7695833 12,17 C12,17.23 12.18625,17.4166667 12.4166667,17.4166667 L16.5875,17.4166667 L16.5833333,21.5829167 C16.5829167,21.8129167 16.7691667,21.9995833 16.9991667,22 L16.9995833,22 C17.2295833,22 17.41625,21.81375 17.4166667,21.58375 L17.4166667,17.4166667 L21.5833333,17.4166667 C21.8133333,17.4166667 22,17.23 22,17 C22,16.7695833 21.8133333,16.5833333 21.5833333,16.5833333"
                        transform="translate(17.000000, 17.000000) rotate(-45.000000) translate(-17.000000, -17.000000) "
                      />
                    </g>
                  </g>
                </g>
              </svg>
            </div>
          </div>
        </div>
      </li>
    </React.Fragment>
  ));

  return (
    <section>
      <section className="container">
        <div className="container">
          <div className="uploadbtn" {...getRootProps({})}>
            {/* <div className="uploadbtn" {...getRootProps({ style })}> */}
            <input {...getInputProps()} />
            <p>
              <AiOutlinePlus /> Upload Documents
            </p>
          </div>
        </div>
        <div>
          <p>File type: .PDF, .PNG, .EXE, .DOC, .DOCX, etc</p>
          {fileFormatError && <p className={css.errorTxt}>File format not supported!!</p>}
        </div>
      </section>
      <aside>
        {/* <div style={{ textAlign: 'center' }}>{fieldUrl}</div> */}
        {/* <h4 style={{ textAlign: 'center' }}>Files</h4> */}
        <ul>{files}</ul>
      </aside>
    </section>
  );
}

export default FileUploader;
